import { render, staticRenderFns } from "./ConfigAlertRocketChat.vue?vue&type=template&id=9c8da9da&scoped=true"
import script from "./ConfigAlertRocketChat.vue?vue&type=script&lang=js"
export * from "./ConfigAlertRocketChat.vue?vue&type=script&lang=js"
import style0 from "./ConfigAlertRocketChat.vue?vue&type=style&index=0&id=9c8da9da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8da9da",
  null
  
)

export default component.exports